import type { GraphQLError } from 'src/services/basket-api/types/BasketAPIResponseBody';
import type { ProductOptionInputWithoutLabel } from 'src/services/basket-api/types/graphql';

const IMAGE_NOT_FOUND = 'IMAGE_NOT_FOUND';

/** Groups each IMAGE_NOT_FOUND error's failed objectUrl (`error.value`) under the
 * optionId at its `path` index in the options array the mutation sent. */
export const mapImageNotFoundUrlsByOption = (
  errors: GraphQLError[],
  sentOptions: ProductOptionInputWithoutLabel,
): Record<number, string[]> => {
  const byOption: Record<number, string[]> = {};
  for (const error of errors) {
    if (error.code !== IMAGE_NOT_FOUND || typeof error.value !== 'string') {
      continue;
    }
    const { path } = error;
    if (!Array.isArray(path) || path[0] !== 'options' || path[2] !== 'value') {
      continue;
    }
    const index = Number(path[1]);
    if (!Number.isInteger(index) || index < 0 || index >= sentOptions.length) {
      continue;
    }
    const optionId = Number(sentOptions[index]?.optionId);
    if (!Number.isInteger(optionId)) {
      continue;
    }
    const existing = byOption[optionId] ?? [];
    if (!existing.includes(error.value)) {
      existing.push(error.value);
    }
    byOption[optionId] = existing;
  }
  return byOption;
};
